import { useQuery } from 'react-apollo';
import { myEmailTemplates } from '../queries';

export function useMyEmailTemplates () {
  const { data, refetch: refresh, loading: isLoading } = useQuery(myEmailTemplates, {
    fetchPolicy: 'no-cache'
  });
  const templates = data?.myEmailTemplates ?
    data?.myEmailTemplates.edges.map(edge => edge.node).filter(node => (node.name === 'default_invitation' || node.accountId != null))
    : [];
  return {
    data: templates,
    refresh,
    isLoading
  };
}
